// extracted by mini-css-extract-plugin
export var dropdownIcon = "_kd-6";
export var imgContainer = "_kd-3";
export var menuIcon = "_kd-5";
export var pillWrapper = "_kd-2";
export var pillsContainer = "_kd-1";
export var subscriptionCard = "_kd-0";
export var subscriptionLogo = "_kd-4";